import React, { ComponentProps, forwardRef } from 'react';
import { Tooltip as TooltipMUI } from '@mui/material';

import { maxWidthMapping } from './Tooltip.api';

type Props = ComponentProps<typeof TooltipMUI> & {
  maxWidth?: keyof typeof maxWidthMapping;
};

// todo: adapt to a/button/div/span
const Tooltip = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { maxWidth, sx, ...rest } = props;

  return (
    <TooltipMUI
      ref={ref}
      {...rest}
      sx={{
        ...(maxWidth && maxWidth !== 'sm' ? { maxWidth: maxWidthMapping[maxWidth] } : {}),
        ...sx,
      }}
    />
  );
});

Tooltip.displayName = 'Tooltip';

export default Tooltip;
